<template>
  <div>
    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  label="Type Name"
                  v-model="formSchema.type_name"
                  :rules="[v => !!v || 'Type name is required !']"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                  label="Short Name"
                  v-model="formSchema.short_name"
                  :rules="[v => !!v || 'Short name is required !']"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <v-btn color="error" @click.native="close">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";

export default {
  props: ["formSchema"],
  components: {
    DatePicker
  },
  data: () => ({
    valid: true,
    show: true,
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? "Edit Voucher Type" : "Add Voucher Type";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },

  created() {
    // commonService.getAllData("operation-activities").then(res => {
    //   if (res.status == "success") {
    //     this.projectList = res.data;
    //   }
    // });
  },

  methods: {
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },

    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;

      if (this.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService.updateFormData(formSchema, "voucher-type").then(res => {
            let actionData = {
              message: res.message,
              data: res.data,
              action: "edit",
              status: res.status
            };
            this.close(actionData);
          });
        } else {
          commonService.insertFormData(formSchema, "voucher-type").then(res => {
            let actionData = {
              message: res.message,
              data: res.data,
              action: "add",
              status: res.status
            };
            this.close(actionData);
          });
        }
      }
    },

    close: function(data) {
      if (data.status == 1) {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/project_info/Voucher/insertForm.vue